import a_gladchenko from '@/assets/a_gladchenko-a.png'
import g_andriishin from '@/assets/g_andriishin-a.png'
import m_shakin from '@/assets/m_shakin-a.png'
import p_presnyakov from '@/assets/p_presnyakov-a.png'
import r_antropov from '@/assets/r_antropov-a.png'
import v_chistilin from '@/assets/v_chistilin-a.png'
import e_biryukova from '@/assets/e_biryukova-a.png'
import m_fyodorova from '@/assets/m_fyodorova.png'

const uchastniki = {
    title: 'Спикеры конференции',
    list: [
        {
            name: {
                raw: 'Елена Бирюкова',
            },
            img: {
                src: e_biryukova,
            },
            // description: '---',
            about: { 
                count: 3,
                list: [
                    'Маркетолог',
                    'Опыт работы в сфере медицины (пациентские и врачебные аудитории) - более 12 лет',
                    'Сооснователь агентства Минтака.Фиджитал, занимается продвижением врачей, клиник, общественных организаций',
                    'Спикер медицинских маркетинговых конференций (Телемедфорум-2022, Личный бренд врача), автор курса (Техноград) «Личный бренд в Нельзяграм»',
                ],
            },
            agenda: [
                {
                    count: 3,
                    title: 'Системный маркетинг: как увеличить прибыль за счет соцсетей',
                    list: [
                        'Основные тенденции продвижения в 2025 году',
                        'Почему нельзя складывать яйца в одну корзину',
                        'Альтернативные площадки: преимущества',
                        'Эмоциональный брендинг: что это и зачем нужен?',
                        'Чат-боты и AI- помощники',
                        'Все о маркировке рекламы: как не попасть на штрафы',
                        // 'Когда и кому нужен личный бренд: сложности, о которых не говорят.',
                        // 'Какие возможности дает раскрученный личный бренд: мифы и реальность.',
                        // 'Кризис, первичные пациенты и личный бренд: в чем связь.',
                        // 'Коллаборация брендированного врача и клиники: как вместе заработать больше.',
                        // 'Важные шаги для развития: с чего начать и как продолжить, чтобы получить результаты.',
                        // 'Особенности развития личного бренда в разных соцсетях',
                    ]
                },
                // {
                //     count: 3,
                //     title: 'Автоматизация процессов и использование ИИ для развития соцсетей и привлечения пациентов',
                //     list: [
                //         'Контент: от постов до видео.',
                //         'Чат-боты: как работать с аудиторией, чтобы она покупала ваши услуги.',
                //         'AI-ассистент: как продавать свои услуги без личного участия.',
                //     ]
                // },
            ]
        },
        {
            name: {
                raw: 'Малика Фёдорова',
            },
            img: {
                src: m_fyodorova,
            },
            // description: '---',
            about: { 
                count: 3,
                list: [
                    'Главный врач, врач-дерматовенеролог, косметолог.',
                    'В эстетической медицине 20 лет.',
                    'Основатель и генеральный директор клиники косметологии “DMClinic”.',
                    'Спикер на конференциях по эстетической медицине.',
                    'Сертифицированный тренер по инъекционным методикам.',
                ],
            },
            agenda: [
                {
                    count: 3,
                    title: 'Первичная консультация-как ключ к записи на несколько месяцев вперед.',
                    list: [
                        'Причинно-следственная связь вашей стратегии, жизненных ценностей и вашей записи.',
                        'Математика правильной плановой косметологии.',
                        'Как ответить на вопрос- зачем мне соц.сети.',
                        'Роль социальных сетях в формировании имиджа и статуса врача.',
                        'Почему пациенты идут не к вам?',
                        'Успешный косметолог — это не просто имя, это поток пациентов, доверие и репутация.',
                        'Первичная консультация главная встреча с пациентом, на которой он ответит да или нет',
                        '3 главных составляющих успеха',

                        // 'Как сформировать запись на несколько месяцев вперед',
                        // 'Роль социальных сетей в формировании имиджа и статуса врача',
                        // 'Почему пациенты идут не к вам? Какой контент привлечет к вам пациентов',
                        // 'Узнайте, как выделиться среди сотен косметологов',
                        // 'Успешный косметолог — это не просто имя: это поток пациентов, доверие и репутация',
                        // 'Первичная консультация: главная встреча с пациентом, на которой он ответит «да» или «нет»',
                        // 'Чего никогда нельзя делать в общении с пациентом',
                        // 'Причинно-следственная связь вашей стратегии, жизненных ценностей и вашей записи',
                        // 'Математика правильной плановой косметологии',
                    ]
                },
            ],
            consult: {
                list: [

                ]
            }
        },
        {
            name: {
                raw: 'Виктор Чистилин',
            },
            img: {
                src: v_chistilin,
            },
            // description: '---',
            about: {
                count: 3,
                list: [
                    'Врач по образованию, в 2003 г. закончил СПб ГПМА',
                    'Автор книги "Витамины для сайта: руководство по развитию медицинских сайтов"',
                    'Автор курса "Поисковая оптимизация сайта клиники"',
                    'Спикер на медицинских конференциях',
                    'Руководитель в TRINET.Medicine',
                ]
            },
            agenda: [
                {
                    count: 3,
                    title: 'Приручаем агрегаторы: пошаговый план для клиник и врачей по увеличению пациентов',
                    list: [
                        'Обзор рынка медицинских агрегаторов — какие площадки работают лучше всего и что учитывать при выборе.',
                        'Как прокачать карточки врачей — практические советы по улучшению анкет, отзывов и рейтинга.',
                        'Как врачу сделать карточку, которая привлекает пациентов — какие детали важно указать, как правильно оформить описание, какие фото и документы повышают доверие и увеличивают запись.',
                        'Что смотреть у конкурентов — как анализировать чужие страницы и использовать эти данные для роста.',
                        'Как вам может помочь менеджер площадки — скрытые возможности агрегаторов, о которых знают не все.',
                        'Запись «в режиме реального времени» как конкурентное преимущество — почему это важно и как внедрить.',
                        '45 ₽ за лид и другие неочевидные «фишки» работы с агрегаторами — кейсы, лайфхаки и нестандартные подходы.',
                        'Когда врач и клиника зря тратят деньги на агрегаторы — в каких случаях реклама не принесет пациентов и что делать вместо этого.',
                    ]
                }
            ],
            consult: {

            }
        },
        {
            name: {
                raw: 'Михаил Шакин',
            },
            img: {
                src: m_shakin,
            },
            // description: '---',
            about: { 
                count: 3,
                list: [
                    'В SEO с 2006 года',
                    'Лауреат премии конференции Optimization "Самая упоминаемая SEO-персона рунета" в течение 5 лет подряд',
                    'Обладатель 5 премий по интернет-маркетингу конференции Baltic Digital Days в Калининграде',
                    'Большой опыт продвижения сайтов по всему миру',
                ],
            },
            agenda: [
                { 
                    count: 3,
                    title: 'Сайт как основа привлечения первичных пациентов',
                    list: [
                        'Мировые тренды ИИ и их применение для врачей и медицинских сайтов.',
                        'Доверие пациентов через экспертность и прозрачность врача и клиники.',
                        'Многостраничный сайт врача, клиники vs лендинг: стратегии для разных задач.',
                        'Контент-маркетинг и SEO: как врачу стать находкой для пациента.',
                        'Удобство сайта как конкурентное преимущество.',
                        
                    ]
                }
            ]
            
        },
        {
            name: {
                raw: 'Руслан Антропов',
            },
            img: {
                src: r_antropov,
            },
            description: 'Организатор конференции Медпервичка',
            about: { 
                count: 3,
                list: [
                    'Опыт и экспертиза в IT и в телекоммуникациях',
                    'С 2018 года в SEO',
                    'Продюсирование YouTube для бизнеса',
                    'Свои проекты в тематике медицина',
                ],
            },
            agenda: [
                {
                    count: 3,
                    title: 'Может ли блог на сайте врача и клиники приносить первичных пациентов? Как это работает?',
                    list: [
                        'Зачем нужен блог для врача и клиники',
                        'Как блог помогает приводить первичных пациентов',
                        'Существуют требования, к медицинскому сайту, которые необходимо соблюдать',
                        'Сколько времени нужно, что бы блог начал приносить трафик и пациентов, и какие есть гарантии?',
                        'Как вести блог? Какие работы надо выполнять? Кто необходим для реализации?',
                    ]
                },
                // {
                //     title: '',
                //     list: [
                //         'тест --- Что же дает видеоконтент',
                //         'тест --- YouTube как площадка для бизнеса',
                //         'тест --- Органическая выдача видеоконтента в поисковых системах гугл и яндекc',
                //     ]
                // }
            ]
        },
        {
            name: {
                raw: 'Павел Пресняков',
            },
            img: {
                src: p_presnyakov,
            },
            // description: '---',
            about: { 
                count: 3,
                list: [
                    'Владелец 6 интернет-магазинов',
                    'Призер конкурса грантов ВКонтакте',
                ],
            },
            agenda: [
                {
                    count: 3,
                    title: 'Личный бренд для врачей в ВК',
                    list: [
                        'Личный бренд в ВК для врача',
                        'Какой контент создавать в ВК врачу',
                        'Как получать подписчиков без бюджета врачу в ВК',
                        'Сообщество ВКонтакте - почему без него никуда ',
                        'Воронки продаж для клиник ',
                        'Какой должен быть контент и как его автоматизировать ',
                        'Рекламные возможности ВКонтакте ',
                        'Сколько стоит один пациент',
                        'ВК видео и ВК клипы - как новый тренд в привлечении пациентов',
                        // 'Сообщество ВКонтакте - почему без него никуда',
                        // 'Воронки продаж для клиник',
                        // 'Какой должен быть контент и как его автоматизировать',
                        // 'Рекламные возможности ВКонтакте',
                        // 'Сколько стоит один пациент',
                        // 'ВК видео и ВК клипы - как новый тренд в привлечении пациентов',
                    ]
                }
            ]
        },
        {
            name: {
                raw: 'Глеб Андриишин',
            },
            img: {
                src: g_andriishin,
            },
            // description: '---',
            about: { 
                count: 3,
                list: [
                    'Опыт работы в SEO с 2019',
                    'В ГЕО маркетинге с 2022',
                    'Маркетолог в федеральной сети Мастер Минутка 2021-2023',
                    'Маркетолог в Софтлайн 2023',
                    'За 2 года работы с картами помогли увеличить посещаемость более 50 организациям по всей РФ',
                ],
            },
            agenda: [
                {
                    count: 3,
                    title: 'Как получать пациентов при помощи ГЕО сервисов',
                    list: [
                        'Изменения и нововведения 2025: новые правила Яндекса',
                        'Преимущества работы с Яндекс Бизнесом',
                        'Введение в Яндекс Бизнес: возможности платформы для бизнеса и актуальность использования Яндекс сервисов в 2024 году',
                        'Стратегия работ над репутацией: на что влияет, как эффективно отвечать на отзывы, как обрабатывать негатив',
                        'Заполнение карточки на Яндекс Бизнесе: основные элементы, роль фотографий, историй и описаний',
                    ]
    
                }
            ],
            consult: {
                list: [
                    {
                        title: '',
                        list: [
                            'ГЕО продвижение клиники на картах',
                            'Создание сайтов',
                            'SEO продвижение сайтов клиник',
                            'Создание приложений и софта',
                            'Личные консультации',
                        ]
                    }
                ]
            }
        },
        {
            name: {
                raw: 'Антон Гладченко',
            },
            img: {
                src: a_gladchenko,
            },
            // description: '---',
            about: { 
                count: 3,
                list: [
                    'В контекстной рекламе с 2008 года',
                    'Основатель агентства комплексного интернет-маркетинга BART (с 2011 года)',
                    'Руководитель агентства и специалистов по ppc, SEO',
                    'Есть проекты и в личном управлении',
                    'Автор телеграм-канала про контекстную рекламу и аналитику https://t.me/bossmarketer (почти 4000 подписчиков)',
                    'Более 300 аудитов контекстной рекламы и 150 клиентов по настройке и ведению за эти годы',
                ],
            },
            agenda: [
                {
                    count: 1,
                    title: 'Продвижение клиники vs. Продвижение врача',
                    // title: 'Telegram для привлечения первичных пациентов',
                    list: [
                        'Развитие бренда врача в Telegram',
                        'Какой контент создавать врачу в Telegram',
                        'Как использовать Telegram Ads для продвижения блога врача',
                        'Привлечение первичных пациентов через Telegram без рекламы',
                        'Эдьютейнмент – ключ к привлечению Ваших пациентов',
                        'Свой канал или бот',
                        '7 грехов, которые мешают врачам привлекать пациентов через Telegram',
                        'Чем раньше начнете, тем лучше. Часики тикают, реклама дорожает',
                        'Зачем Telegram клинике сегодня',
                        'Прямая реклама или развитие бренда',
                        'Telegram Ads: плюсы и минусы для клиник',
                    ]
                },
                {
                    count: 1,
                    title: 'Привлечение первичных пациентов через Яндекс Директ',
                    list: [
                        'Форматы рекламы в Яндекс, которые подходят клиникам',
                        'Сквозная аналитика - ключ к успеху рекламы клиники',
                        'Борьба с фродом и оптимизация на целевые заявки от пациентов',
                        'Автостратегии в мед. рекламе',
                        'Важность комплексного подхода, медийности и как это влияет на лиды с Яндекс Директ',
                    ]
                },
            ]
        },
        
        
    ],
}
export default uchastniki